import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import type { InventoryFilterState } from "../lib/url-state";

import { stockKeys } from "./query-keys";

export function useListStock(filter: InventoryFilterState, enabled = true) {
  return useQuery({
    queryKey: stockKeys.list(filter),
    enabled,
    queryFn: async () => {
      const query: {
        marketplace?: "shopee" | "lazada" | "tiktok";
        status?: "healthy" | "low_stock" | "out_of_stock" | "oversold";
        search?: string;
        offset?: number;
        limit?: number;
        sort_key?:
          | "sku"
          | "product_name"
          | "on_hand"
          | "sellable"
          | "allocation_sellable"
          | "last_synced_at"
          | "status_code";
        sort_dir?: "asc" | "desc";
      } = { limit: filter.limit ?? 50 };

      if (filter.marketplace !== undefined) query.marketplace = filter.marketplace;
      if (filter.status !== undefined) query.status = filter.status;
      if (filter.search) query.search = filter.search;
      if (filter.offset > 0) query.offset = filter.offset;
      if (filter.sortKey) query.sort_key = filter.sortKey;
      if (filter.sortDir) query.sort_dir = filter.sortDir;

      const { data, error } = await apiClient.GET("/v1/stock", {
        params: { query },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
